import { AccountIbans } from '../type';

export const hasIban = (v?: AccountIbans[]) => v && v.length > 0;
